










































import {
    Component,
    Prop,
    Advisor,
    BaseView,
    QAFlowStepsNavigation,
    ComponentStyle,
    ComponentStyleDefinition,
    VueComponent,
    InjectComponent,
    SectionType,
} from "@zoovu/runner-browser-api";
import {isRecommendationBundles} from "./utils";

@Component({})
export default class QuestionnaireView extends BaseView {
    @InjectComponent("AdvisorSectionView")
    advisorSectionView!: VueComponent;

    @InjectComponent("PageView")
    pageView!: VueComponent;

    @InjectComponent("BrandingView")
    brandingView!: VueComponent;

    @InjectComponent("AdviceView")
    adviceView!: VueComponent;

    @InjectComponent("AdviceBundleView")
    adviceBundleView!: VueComponent;

    @Prop({default: true})
    showPageSelectorBetweenNavigationButtons!: boolean;

    @Prop({default: false})
    showPageSelectorAboveMainSection!: boolean;

    @Prop()
    advisor!: Advisor;

    @ComponentStyle()
    componentStyle!: ComponentStyleDefinition;

    // NOTE @m.fret This is a workaround for an empty flow that can happen when the progressive filters are applied on the first question.
    get hasQuestions(): boolean {
        const hasQuestions = this.advisor.flowStepsNavigation.flowSteps.length > 0;
    
        if (!hasQuestions) {
            console.error("There are no questions to be displayed. Please verify if your Progressive Filtering settings are not filtering out all the available answer options.");
        }

        return hasQuestions;
    }

    get shouldShowPageSelectorBetweenNavigationButtons() : boolean {
        return this.showPageSelectorBetweenNavigationButtons && this.hasQuestions;
    }

    get shouldShowPageSelectorAboveMainSection() : boolean {
        return this.showPageSelectorAboveMainSection && this.hasQuestions;
    }

    get navigation(): QAFlowStepsNavigation {
        return this.advisor.flowStepsNavigation;
    }

    get lastFlowStep(): boolean {
        return !this.advisor.flowStepsNavigation.hasNext;
    }

    get SectionType(): typeof SectionType {
        return SectionType;
    }

    get rootElementClass(): string {
        return "questionnaire-wrapper";
    }

    get isBundle(): boolean {
        return isRecommendationBundles(this.advisor.advice);
    }
}
